const SESSION_SUFFIX = ':session';
const SESSION_ID_PATTERN = /^[A-Za-z0-9_-]{8,80}$/;

export function newAskAiSessionId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (ch) => {
    const nibble = (Math.random() * 16) | 0;
    const value = ch === 'x' ? nibble : (nibble & 0x3) | 0x8;
    return value.toString(16);
  });
}

export function isValidAskAiSessionId(value: string): boolean {
  return SESSION_ID_PATTERN.test(String(value || '').trim());
}

export function getOrCreateAskAiSessionId(storageKey: string): string {
  const key = `${storageKey}${SESSION_SUFFIX}`;
  try {
    const existing = String(sessionStorage.getItem(key) || '').trim();
    if (isValidAskAiSessionId(existing)) return existing;
    const created = newAskAiSessionId();
    sessionStorage.setItem(key, created);
    return created;
  } catch {
    return newAskAiSessionId();
  }
}

export function resetAskAiSessionId(storageKey: string): string {
  const created = newAskAiSessionId();
  try {
    sessionStorage.setItem(`${storageKey}${SESSION_SUFFIX}`, created);
  } catch {
    // sessionStorage can be unavailable in private browsing
  }
  return created;
}

export function clearAskAiSessionId(storageKey: string): void {
  try {
    sessionStorage.removeItem(`${storageKey}${SESSION_SUFFIX}`);
  } catch {
    // ignore
  }
}
